module.exports = __webpack_public_path__ + "static/media/icon-nav-dashboard-on.e893058b.svg";